import React, { useState } from 'react'

import { useModal } from '../../hooks/modal'
import { useDeleteRequest, useRequest } from '../../hooks/request'
import { TOTAL_EXPENSE_DETAIL, TOTAL_EXPENSE_TOGGLE_ARCHIVE } from '../../urls'
import TotalExpenseUpdate from './TotalExpenseUpdate'
import { getPayment, getPaymentTypeOptions, getTur } from '../../utils/types'
import { getDate } from '../../utils/date'
import { maxLength } from '../../utils/string'
import Button from '../../components/common/Button'

export default function TotalExpenseItem({ item, index, expenseReport }) {
    const [isToggling, setIsToggling] = useState(false)
    const productRemove = useDeleteRequest({ url: TOTAL_EXPENSE_DETAIL.replace('{id}', item.id) })
    const toggleArchive = useRequest({
        method: 'PATCH',
        url: TOTAL_EXPENSE_TOGGLE_ARCHIVE.replace('{id}', item.id)
    })

    async function onDelete() {
        if (global.confirm('Вы действительно хотите удалить?')) {
            await productRemove.request()
            expenseReport.request()
        }
    }

    async function onToggleArchive() {
        if (isToggling) return

        setIsToggling(true)
        try {
            const result = await toggleArchive.request()
            if (result) {
                expenseReport.request() // Refresh the list
            }
        } catch (error) {
            console.error('Failed to toggle archive status:', error)
        } finally {
            setIsToggling(false)
        }
    }

    const [showUpdateModal, hideUpdateModal] = useModal(
        <TotalExpenseUpdate
            clients={item}
            item={item}
            onCancel={() => {
                expenseReport.request()
                hideUpdateModal()
            }}
        />,
    )

    function format(value) {
        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
            useGrouping: true,
        })
            .format(value)
            .replace(/,/g, ' ')
    }

    const getSpaceTypeDisplay = (spaceType) => {
        switch (spaceType) {
        case 'active': return 'Фаол'
        case 'archive': return 'Архив'
        default: return '-'
        }
    }

    const getSpaceTypeClassName = (spaceType) => {
        if (spaceType === 'active') return 'is-success is-light'
        if (spaceType === 'archive') return 'is-warning is-light'
        return 'is-light'
    }

    return (
        <tr className={`is-size-6 ${item.spaceType === 'archive' ? 'has-background-light' : ''}`} key={item.id}>
            <td className="is-size-6">{index + 1}</td>
            <td className="is-size-6">{getDate(item?.date)}</td>
            <td className="is-size-6">{item?.selectAssigned.username}</td>
            <td className="is-size-6">{getPayment(item?.status)}</td>
            <td className="is-size-6">{item?.selectCategory.name ? `${item?.selectCategory.name}` : 'Кирим'}</td>
            <td className="is-size-6" style={{ color: item?.status === 'income' ? 'green' : 'red' }}>
                {format(item?.amount)} Сум
            </td>
            <td className="is-size-6">{getPaymentTypeOptions(item?.paymentType)}</td>
            <td className="is-size-6">{getTur(item?.types)}</td>
            <td className="is-size-6">
                <span
                    className={`tag ${getSpaceTypeClassName(item?.spaceType)}`}
                    style={{
                        fontWeight: 'bold',
                        borderRadius: '20px',
                        padding: '0.4em 0.8em',
                        fontSize: '0.85em'
                    }}
                >
                    {item?.spaceType === 'active' && <ion-icon name="checkmark-circle" style={{ marginRight: '4px' }} />}
                    {item?.spaceType === 'archive' && <ion-icon name="archive" style={{ marginRight: '4px' }} />}
                    {getSpaceTypeDisplay(item?.spaceType)}
                </span>
            </td>
            <td className="is-size-6">{maxLength(item?.comment, 24)}</td>
            <td>
                <div style={{ display: 'flex' }} className="has-text-right">
                    <Button
                        onClick={onToggleArchive}
                        disabled={isToggling}
                        className={`mr-2 button is-small is-outlined ${
                            item.spaceType === 'archive' ? 'is-success' : 'is-warning'
                        }`}
                        icon={item.spaceType === 'archive' ? 'checkmark' : 'archive'}
                        title={item.spaceType === 'archive' ? 'Фаоллаштириш' : 'Архивлаш'}
                    />
                    <Button onClick={showUpdateModal} className="mr-2 button is-success is-outlined is-small" icon="pencil-outline" />
                    <Button onClick={onDelete} className="button is-danger mr-2 is-outlined is-small" icon="trash" />
                </div>
            </td>
        </tr>
    )
}
